export default "__VITE_ASSET__CmVaVhy2__"